(function ($) {

    $(document).ready(function () {

        const $osmMaps = $('.osm-map.populate');
        /** @type {OpenStreetMapFunctions[]} */
        let allOpenStreetMapFunctions = [];
        if($osmMaps.length){
            $osmMaps.each( (index, element) => {
                const $osmMap = $(element);
                const isSolicitorMap = $osmMap.hasClass("solicitor-map");
                const $markerPopUps = $osmMap.find(".marker");
                const openStreetMapVO = createDefaultOpenStreetVO($osmMap, $markerPopUps);
                /** @type {OpenStreetMapFunctions} */
                let openStreetMapFunctions = null;

                openStreetMapVO.mapHeight = 460;
                if(isSolicitorMap){
                    openStreetMapVO.markerIcon.iconUrl = "/app/themes/hailstone/img/layout/solicitor-icon.png";
                    openStreetMapVO.userMarkerIcon.iconUrl = "/app/themes/hailstone/img/layout/home-icon.png";
                    openStreetMapVO.mapHeight = 640;
                    determineUserLatLng(openStreetMapVO);
                }

                openStreetMapFunctions = createOpenStreetMap(openStreetMapVO);
                allOpenStreetMapFunctions.push(openStreetMapFunctions);
            });
        }


        const onShownListener = () => {
            for(let i = 0; i < allOpenStreetMapFunctions.length; i ++){
                allOpenStreetMapFunctions[i].onShowMapClicked()
            }
        }

        document.addEventListener('refresh-open-street-map', onShownListener, false);
    });
})(jQuery);